const { isStringValid } = require("simpul");

const makeHashtagLabel = (hashtag, alt) =>
  isStringValid(hashtag)
    ? hashtag.startsWith("#")
      ? alt
        ? hashtag.substring(1)
        : hashtag
      : alt
      ? hashtag
      : "#" + hashtag
    : "";

module.exports = makeHashtagLabel;
